import { get } from 'svelte/store';
import { user_settings } from 'src/stores/account/user';
import type { ChartControlsDataInterface } from 'src/helpers/statistics/ui/chart_control_helpers';
import type { ChartDataInterface, ChartStatisticInterface } from 'src/types/Chart';
import type { GetStatsResponseData } from 'src/types/requests/charts/get_stats_period';
import { getEnergyStatistics } from './energy_statistics_repository';
import type { EnergyMonitoringPeriodId } from './period_helpers';

export type EnergyStatisticsResult = {
	chartData: ChartDataInterface;
	statistic: ChartStatisticInterface;
	history: GetStatsResponseData['history'];
	devices?: GetStatsResponseData['devices'];
	interval?: GetStatsResponseData['interval'];
};

export type FetchEnergyStatisticsOptions = {
	mergeLastHour?: boolean;
	/** When false, return raw history even if chart series would be empty (heatmap). */
	requireChartData?: boolean;
};

export const fetchEnergyStatistics = (
	controls: ChartControlsDataInterface,
	periodId: EnergyMonitoringPeriodId,
	roomId?: number | null,
	options: FetchEnergyStatisticsOptions = {},
): Promise<EnergyStatisticsResult | null> =>
	getEnergyStatistics({
		scope: { kind: 'account', roomId },
		controls,
		periodId,
		currency: get(user_settings)?.currency ?? '',
		options,
	});
